module.exports = __webpack_public_path__ + "sunsemweb/img/q.4cd98244.png";